module.exports = __webpack_public_path__ + "img/store-google-black.c007b91.png";